import { DeleteUserBase } from "../DeleteUserBase";

/**
 * Delete a driver.
 */
export const DeleteDriver = () => (<DeleteUserBase defaultRoleGroup={'Driver'} />);
